import { type } from "../../types/types";

export default function reducer(state = { country: {} }, action) {
  switch (action.type) {
    case type.SET_COUNTRY:
      return { ...state, ...action.country };
    default:
      return state;
  }
}
